<template>
  <div>
    <pending-review-list
      v-on:showCards="hideCards = $event"
    ></pending-review-list>

    <template v-if="(is_admin || is_manager) && !hideCards">
      <header-card
        icon="360"
        title="360 Review Management"
        sub-title="See how your employees are reviewed by their peers"
      >
        <template v-slot:right>
          <engagement-text
            v-if="overview.userRecords"
            title="Participation Rate"
            :engagement="overview.userRecords"
          ></engagement-text>
        </template>
        <template v-slot:extension>
          <v-divider></v-divider>
          <v-row dense>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
              <v-btn text to="/reporting/360-reviews" color="secondary" block>
                <v-icon class="mr-2">assessment</v-icon>
                Reporting
              </v-btn>
            </v-col>
            <template v-if="is_admin">
              <v-divider
                vertical
                v-if="$vuetify.breakpoint.mdAndUp"
              ></v-divider>
              <v-col :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'">
                <v-btn
                  text
                  to="/features/reviews/settings"
                  color="secondary"
                  block
                >
                  <v-icon class="mr-2">settings</v-icon>
                  Admin Settings
                </v-btn>
              </v-col>
            </template>
          </v-row>
        </template>
      </header-card>
      <v-row v-if="profile.isManager">
        <v-col cols="12">
          <ad-header-card
            title="Manage who reviews each team member"
            subtitle="As the manager of your team, you have the ability to control who reviews each member in your group. Look for the blue icon below to control the reviewers of each individual."
          >
            <template v-slot:titleExtension>
              <v-icon color="info" class="ml-2" small>group_add</v-icon>
            </template>
          </ad-header-card>
        </v-col>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Team 360's
            </v-card-title>
            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="report.members"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100]
              }"
              @click:row="rowClick"
              class="row-pointer"
            >
              <template v-slot:item.name="{ item }">
                <user-chip v-if="item.user" :user="item.user"></user-chip>
              </template>
              <template v-slot:item.userRecords.completion="{ item }">
                <simple-engagement-text
                  inherit
                  :engagement="item.userRecords"
                ></simple-engagement-text>
              </template>
              <template v-slot:item.score.value="{ item }">
                <v-icon v-if="!item.score.value" color="lighttext">
                  remove
                </v-icon>
                <template v-else>
                  <v-icon small :color="$coreScores.getColor(item.score.value)">
                    fiber_manual_record
                  </v-icon>
                  <span class="secondarytext--text">
                    {{ item.score.value | one_decimal }}
                  </span>
                </template>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn
                  @click.stop="editReviewers(item)"
                  color="info"
                  icon
                  class="ml-2"
                >
                  <v-icon>group_add</v-icon>
                </v-btn>
                <v-btn icon color="secondary" class="ml-2">
                  <v-icon>insert_chart_outlined</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <edit-user-reviewer-dialog
      ref="editReviewerDialog"
    ></edit-user-reviewer-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PendingReviewList from "@/components/reviews/PendingReviewList";
import HeaderCard from "@/components/common/HeaderCard";
import EngagementText from "@/components/reporting/EngagementText";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
import EditUserReviewerDialog from "@/components/reviews/EditUserReviewerDialog";
import AdHeaderCard from "@/components/common/AdHeaderCard";
export default {
  name: "ReviewOverview",
  components: {
    PendingReviewList,
    HeaderCard,
    EngagementText,
    SimpleEngagementText,
    EditUserReviewerDialog,
    AdHeaderCard
  },
  data: () => ({
    loading: false,
    search: "",
    hideCards: false
  }),
  watch: {
    profile(val, oldVal) {
      if (val == oldVal) {
        return;
      }
      this.getData();
    }
  },
  computed: {
    headers() {
      let list = [{ text: "Name", value: "name" }];
      list.push({ text: "Participation", value: "userRecords.completion" });

      list.push({ text: "Reviewers", value: "reviewers", align: "center" });

      list.push(
        { text: "Score", value: "score.value" },
        { text: "", value: "action" }
      );
      return list;
    },
    ...mapGetters({
      report: "reporting/review",
      pending: "review/pending",
      profile: "profile/profile",
      overview: "review/overview",
      is_admin: "profile/is_admin",
      is_manager: "profile/is_manager"
    })
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      let callArray = [this.$store.dispatch("review/getPendingReviews")];
      if (this.is_admin || this.is_manager) {
        callArray.push(this.$store.dispatch("review/getReviewOverview"));
      }
      if (this.profile.isManager) {
        callArray.push(
          this.$store.dispatch("reporting/getReviewMembers", {
            managerId: this.profile.id
          })
        );
      }
      Promise.all(callArray)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your reviews."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editReviewers(item) {
      this.$refs.editReviewerDialog.showDialog(item.user, true);
    },
    rowClick(item) {
      this.$router.push({
        path: `/reporting/360-reviews/score/members/${item.user.id}`
      });
    }
  }
};
</script>
